import { DataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

export class ReferencedProduct {
	constructor(
		public readonly id: string,
		public readonly currentWholesalePrice: Price | null,
		public readonly dataSource: DataSource
	) {}
}
